module.exports = __webpack_public_path__ + "static/media/vampiress_head.f1b30f86.png";